export enum WhatsAppSettingsTab {
  ADMIN_NOTIFICATIONS = 'adminnotifications',
  CUSTOMER_CONFIRMATIONS = 'customerconfirmations',
  CUSTOMER_REMINDERS = 'customerreminders',
}

export const WHATSAPP_SETTINGS_TABS = [
  WhatsAppSettingsTab.ADMIN_NOTIFICATIONS,
  WhatsAppSettingsTab.CUSTOMER_CONFIRMATIONS,
  WhatsAppSettingsTab.CUSTOMER_REMINDERS,
];

export const MAX_EXTRA_LINES_CHARS = 700;
